import React, { useCallback, useMemo } from 'react';
import { Text, useTheme } from '@ui-kitten/components';
import lodashFilter from 'lodash/filter';
import lodashIsEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import constants from '../Config/constants';
import useDetailsController from '../Screens/Store/controller/details';
import ThemeColor from '../Theme/colors';
import ThemeStyle from '../Theme/styles';

import Button from './Button';
import SwitchTab from './SwitchTab';

const SwitchTabOrderType = (props) => {
  const store_theme = useTheme();
  const { storeOrderTypes, selectedOrderType, updateShopOrderType } =
    useDetailsController({ isModal: false });

  const buttonColor = store_theme['button_color'];
  const buttonTextColor = store_theme['button_text_color'];

  const orderTypes = useMemo(() => {
    if (props.showMealPlan) return storeOrderTypes;
    return lodashFilter(
      storeOrderTypes,
      (d) => d.value !== constants.ORDER_TYPES.MEAL_PLAN,
    );
  }, [props.showMealPlan, storeOrderTypes]);

  // web specific UI
  const _renderItem = useCallback(
    (data, _index, { isButtonActive, isTextActive }) => {
      const applyButtonColor = isButtonActive && buttonTextColor;
      return (
        <Button
          key={data.value}
          style={({ hovered }) => [
            ThemeStyle.flex1,
            ThemeStyle.flexDirectionRowCenterCenter,
            { paddingVertical: 15 },
            hovered &&
              !isButtonActive && {
                borderRadius: 5,
                backgroundColor: buttonColor
                  ? `${buttonColor}1A`
                  : ThemeColor.green100,
              },
          ]}
          onPress={() => !isButtonActive && updateShopOrderType(data)}
          isHoverable
        >
          <Text
            category="c1"
            status={isTextActive ? 'control' : 'primary'}
            style={applyButtonColor && { color: buttonTextColor }}
          >
            {data.label}
          </Text>
        </Button>
      );
    },
    [buttonColor, buttonTextColor, updateShopOrderType],
  );

  const conditionalStyle = useMemo(() => {
    if (constants.isWeb) {
      return {
        activeColor: buttonColor,
        containerStyle: {
          ...ThemeStyle.flexDirectionRow,
          borderRadius: 5,
          zIndex: 1,
        },
        renderItem: _renderItem,
      };
    }
    return {};
  }, [buttonColor, _renderItem]);

  if (lodashIsEmpty(orderTypes)) return null;

  return (
    <SwitchTab
      data={orderTypes}
      value={selectedOrderType || null}
      onChange={updateShopOrderType}
      {...conditionalStyle}
      {...props}
    />
  );
};

SwitchTabOrderType.propTypes = {
  size: PropTypes.string,
  showMealPlan: PropTypes.bool,
};

export default React.memo(SwitchTabOrderType);
